var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"label-inp"},[_c('td',{staticClass:"flex style-l"},[_c('div',{staticClass:"font-bold w-1/2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ml-4 category"},[_vm._v(" "+_vm._s(_vm.category)+" ")])]),_c('td',{staticClass:"data"},[_vm._v(" "+_vm._s(_vm.data)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }